import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import apiClient from '../api/client';
import { useAuth } from '../context/AuthContext';
import './Dashboard.css';

export default function PartnerDashboard() {
  const { user } = useAuth();
  const [referrals, setReferrals] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiClient.get('/referrals/mine').then((res) => setReferrals(res.data.referrals)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="dashboard-page">
      <div className="container">
        <div className="dashboard-header">
          <div>
            <span className="eyebrow">Referral Partner</span>
            <h1>{user?.organizationName || user?.fullName}</h1>
          </div>
          <Link to="/refer" className="btn btn-primary">Submit New Referral</Link>
        </div>

        {loading ? <p>Loading…</p> : !referrals.length ? (
          <div className="card empty-state">No referrals submitted yet.</div>
        ) : (
          <table className="data-table card">
            <thead>
              <tr><th>Client</th><th>Urgency</th><th>Status</th><th>Submitted</th></tr>
            </thead>
            <tbody>
              {referrals.map((r) => (
                <tr key={r.id}>
                  <td>{r.patientFullName}</td>
                  <td>{r.urgency}</td>
                  <td><span className={`status-pill status-${r.status === 'received' ? 'requested' : 'confirmed'}`}>{r.status}</span></td>
                  <td>{new Date(r.createdAt).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
